import Vue from "vue";
import Router, {RouterOptions, RouteConfig} from "vue-router";

import VueRouter from "vue-router";

import AuthLayout from "@/components/auth/Layout.vue";
import SignIn from "@/components/auth/SignIn.vue";

import LfsLayout from "@/components/lfs/Layout.vue";
import ProductList from "@/components/lfs/ProductList.vue";
import Products from "@/components/lfs/Products.vue";

import Statistics from "@/components/lfs/Statistics.vue";
//import Survey from "@/components/lfs/Survey/Page.vue";
import Surveys from "@/components/lfs/Surveys/Surveys.vue";
import Survey from "@/components/lfs/Surveys/Survey.vue";
import SurveysDemo from "@/components/lfs/Surveys/Demo.vue";

import ProfileInfo from "@/components/lfs/ProfileInfo.vue";
import Privacy from "@/components/common/Privacy/Privacy.vue"

import ShardList from "@/components/lfs/ShardList.vue";
import NewShardList from "@/components/lfs/NewShardList.vue";
import ShCommonList from "@/components/lfs/ShardList/common/CommonList.vue";
import ShBadgeList from "@/components/lfs/ShardList/badge/BadgeList.vue";
import ShCompanyList from "@/components/lfs/ShardList/company/CompanyList.vue";
import ShProductList from "@/components/lfs/ShardList/product/ProductList.vue";
import ShSurveyList from "@/components/lfs/ShardList/survey/SurveyList.vue";
import ShGuestList from "@/components/lfs/ShardList/guest/GuestList.vue";

import StatCollectedData from "@/components/lfs/Statistics/CollectedData.vue";
import StatStandmans from "@/components/lfs/Statistics/Standmans.vue";
import StatSurveys from "@/components/lfs/Statistics/Surveys.vue";

import Support from "@/components/lfs/Support/Page.vue";
import Localization from '@/components/lfs/Localiztion/Page.vue';
// import Testing from '@/components/lfs/Testing/Testing.vue';

import {checkPro, checkProBusiness, checkNotAuthenticated, checkAuthenticated} from "./guards";
import QrLink from '@/components/lfs/QRLink/QrLink.vue';
import QrStand from '@/components/lfs/QRLink/QrStand.vue';
import QrProduct from '@/components/lfs/QRLink/QrProduct.vue';
import QrBadge from '@/components/lfs/QRLink/QrBadge.vue';
import QrNone from '@/components/lfs/QRLink/QrNone.vue';
import QrList from '@/components/lfs/QRLink/QrList.vue';
import PageStatistics from '@/components/lfs/NewStatistics/PageStatistics.vue';
import Standmans from '@/components/lfs/Standmans.vue';
import ContactBlock from "@/components/lfs/ContactBlock.vue";
import Report from "@/components/lfs/NewStatistics/pdf/Report.vue";
import Logout from "@/components/lfs/Logout.vue";

Vue.use(Router);

const routes: RouteConfig[] = [
  {
    path: "/auth",
    name: "Auth",
    component: AuthLayout,
    redirect: {name: "Signin"},
    beforeEnter: (to, from, next) => {
      checkNotAuthenticated(to, from, next).then(() => {
        next();
      });
    },
    children: [
      {
        path: "signin",
        name: "Signin",
        component: SignIn,
      },
    ],
  },
  {
    path: "/",
    name: "Home",
    redirect: {name: "ShardList"},
    beforeEnter: (to, from, next) => {
      checkAuthenticated(to, from, next).then(() => {
        next();
      });
    },
  },
  { path: "*",
    redirect: {name: "Home"}
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: Privacy,
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout,
  },
  {
    path: "/show",
    component: LfsLayout,
    beforeEnter: (to, from, next) => {
      checkAuthenticated(to, from, next).then(() => {
        next();
      });
    },
    children: [
      {
        path: "products",
        name: "Products",
        component: Products,
        props: true,
      },
      {
        path: "shards",
        name: "ShardList",
        component: NewShardList,
        props: true
        },
      {
        path: "statistics",
        name: "Statistics",
        component: PageStatistics,
        props: true,
        beforeEnter: (to, from, next) => {
          checkProBusiness(to, from, next).then(() => {
            next();
          });
        }
      },
      {
        path: "pdf",
        name: "Report",
        component: Report,
        beforeEnter: (to, from, next) => {
          checkProBusiness(to, from, next).then(() => {
            next();
          });
        },
        props: true,
      },
      {
        path: "surveys",
        name: "Surveys",
        component: Surveys,
        props: true,
        beforeEnter: (to, from, next) => {
          checkPro(to, from, next).then(() => {
            next();
          });
        },
      },
      {
        path: "surveys/:survey",
        name: "Survey",
        component: Survey,
        props: true,
        beforeEnter: (to, from, next) => {
          checkPro(to, from, next).then(() => {
            next();
          });
        },
      },
      {
        path: "surveysDemo",
        name: "SurveysDemo",
        component: SurveysDemo,
      },
      {
        path: "support",
        name: "Support",
        component: Support
      },
      {
        path: "profile",
        name: "Profile",
        component: ProfileInfo,
        props: true,
      },
      {
        path: "standmans",
        name: "Standmans",
        component: Standmans,
        props: true,
      },
      {
        path: "contacts",
        name: "ContactBlock",
        component: ContactBlock,
      },
    ],
  },
];

const options: RouterOptions = {
  mode: "history",
  base: process.env.BASE_URL,
  routes,
};

const router = new VueRouter(options);

export default router;
